<template>
    <div class="post-box">
        <!--<div class="post-media"
             :style="{ backgroundImage: 'url(http://icons.iconarchive.com/icons/martz90/circle-addon2/512/help-icon.png)'}"></div>-->
        <div class="post-content text-left">
            <h6 class="post-title">
                <!--{{ t.help_usage }}-->
                Live Casino
            </h6>

            <router-link :to="{ name: 'LiveCasino'}">
                <img width="100%" src="/static/assets/img/rivalo/masonryBigThumbnail.jpeg">
            </router-link>
            <!--<a class="post-link" href="#"><i class="os-icon os-icon-arrow-right7"></i>
                <span>{{ t.detail }}</span>
            </a>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'liveCasinoBanner',
        data () {
            return {
                msg: ''
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/liveCasinoBanner.vue